import { Pin } from '../../../assets';
import { DEFAULT_IMAGE } from '../../../models/domain/const';
import { getStrapiMedia } from '../../../utils/media';
import ImageWithFallback from '../../image-with-fallback/ImageWithFallback';
import { CardStyled, Location } from './CardLocation.style';

interface CardLocationProps {
  data: {
    address?: string;
    image?: any;
  };
  isPrerenderRequest: boolean;
}

const CardLocation: React.FC<CardLocationProps> = ({
  data,
  isPrerenderRequest,
}: CardLocationProps) => {
  const { address, image } = data || {};

  return (
    <CardStyled>
      <Pin />
      {address && (
        <Location
          dangerouslySetInnerHTML={{ __html: address ?? '' }}
        ></Location>
      )}
      {image && image.data && image.data.attributes && (
        <ImageWithFallback
          layout="intrinsic"
          width={image?.data?.attributes?.width}
          height={image?.data?.attributes?.height}
          objectFit="contain"
          src={getStrapiMedia(image?.data?.attributes?.url ?? '')}
          alt={image?.data?.attributes?.alternativeText || ''}
          fallbackSrc={DEFAULT_IMAGE}
          isPrerenderRequest={isPrerenderRequest}
        />
      )}
    </CardStyled>
  );
};

export default CardLocation;
